// The ONLY place face-claim code learns which event it works for.
//
// It adapts the guest event identity (src/eventIdentity.js, mutated by EventRouteGate alone) into
// the event a claim request may target: the frozen scope's validated name and the matching event Home
// route. There is deliberately NO URL / AppContext / sessionStorage fallback: without an active scope
// (invalid route, event switch in progress) callers get null and must make NO claim request.
//
// Callers capture the returned object once per flow/page and re-check `isCurrent()` after every await
// and before any shared write (storage, state, timers, navigation). Staleness is by scope OBJECT
// identity, so A -> B -> A leaves the first A's captures stale.
import { getEventScope, isCurrentScope } from "../../../eventIdentity";

export const FACE_FLOW_ATTRACTIONS = Object.freeze(["swingies", "minimove"]);

export const attractionOf = (eventName) =>
  typeof eventName === "string" ? eventName.split("_")[0].toLowerCase() : "";

// Face holds exist for Swingies and MiniMove only (MiniMe is a different attraction).
export const isFaceFlowEventName = (eventName) =>
  FACE_FLOW_ATTRACTIONS.includes(attractionOf(eventName));

// { scope, eventName, homeRoute, isCurrent } for the active guest event, or null.
export const getFaceClaimEvent = () => {
  const scope = getEventScope();
  if (!scope || !isFaceFlowEventName(scope.name)) return null;
  return Object.freeze({
    scope,
    eventName: scope.name,
    // The validated Home route of THIS event (the gate decodes the URL segment, so it is re-encoded here).
    homeRoute: `/${encodeURIComponent(scope.name)}`,
    isCurrent: () => isCurrentScope(scope),
  });
};
